<div class="timeline">
  <div *ngFor="let event of events" class="timeline-row">
    <div class="timeline-marker">
      <div class="timeline-dot"></div>
      <div class="timeline-line"></div>
    </div>

    <div class="timeline-item">
      <div class="timestamp">
        {{ event.title }}
        {{ "event.by" | translate }}
        {{ event.user?.name }}
        {{ "event.in" | translate }}
        {{ event.timestampFormatted }}
      </div>

      <ng-container *ngIf="getLabeler(event.topic) as labeler; else rawText">
        <div
          class="change-card"
          *ngIf="
            event.oldReference !== undefined && event.reference !== undefined
          "
        >
          <dependent-choice
            [selectedId]="event.oldReference"
            [topic]="event.topic"
            [showLabel]="true"
            [labelOnDemand]="labeler"
            [reduced]="true"
          ></dependent-choice>
          <span class="arrow">→</span>
          <dependent-choice
            [selectedId]="event.reference"
            [topic]="event.topic"
            [showLabel]="true"
            [labelOnDemand]="labeler"
            [reduced]="true"
          ></dependent-choice>
        </div>
      </ng-container>

   <ng-template #rawText>
  <div class="change-card" *ngIf="event.oldReference || event.reference || (event.topic === 'comment' && event.commentContent)">
    <ng-container *ngIf="event.topic === 'comment'; else defaultRefs">
      <div class="comment-content">

        <span>{{ event.commentContent }}</span>
      </div>
    </ng-container>
    <ng-template #defaultRefs>
      <span *ngIf="event.oldReferenceLabel">{{ event.oldReferenceLabel }}</span>
      <span *ngIf="event.oldReferenceLabel && event.referenceLabel" class="arrow">→</span>
      <span *ngIf="event.referenceLabel">{{ event.referenceLabel }}</span>
    </ng-template>
  </div>
</ng-template>


      <div
        class="description"
        *ngIf="event.description && (!event.reference || !event.oldReference)"
      >
        {{ event.description }}
      </div>








<div *ngIf="event.topic === 'media' && event.mediaPreviewUrl" class="media-preview">
  <img
    [src]="event.mediaPreviewUrl"
    alt="Media Preview"
    class="timeline-media-image"
  />
</div>




    </div>



  </div>
</div>
